import { DateTime } from "luxon";
const createJointBidderPayload = async (
  eventData: any,
  allBiddersData: any,
  banker: any,
  bank: any,
  currentBranch: any,
  primaryBidderIndex: any,
  isOverwrite: any = false,
) => {
  console.log("testing joint bidder payload");

  // const eventData: any = await getAuctionEventById(for_event);

  // payload["meta"] =
  // payload["digio_request_status"] = "approved";
  // payload["event_uuid"] = eventData?.uuid;
  // const formatBidderNames = () => {
  //   if (!Array.isArray(allBiddersData) || allBiddersData.length === 0)
  //     return "";

  //   // Ensure primaryIndex is within bounds
  //   if (primaryBidderIndex < 0 || primaryBidderIndex >= allBiddersData.length) {
  //     throw new Error("Invalid primary index");
  //   }

  //   const primary = allBiddersData[primaryBidderIndex].name;
  //   const secondary = allBiddersData
  //     .filter((_, idx) => idx !== primaryBidderIndex)
  //     .map((bidder) => bidder.name)
  //     .filter(Boolean)
  //     .join(", ");

  //   if (secondary) {
  //     return `${primary}, ${secondary}`;
  //   } else {
  //     return `${primary}`;
  //   }
  // };

  const getPrimaryBidderPayload = () => {
    console.log("primaryBidderIndex: ", primaryBidderIndex);
    let payload: any = {};
    if (
      allBiddersData[primaryBidderIndex].kyc_verified &&
      allBiddersData[primaryBidderIndex].emd_amount_paid &&
      allBiddersData[primaryBidderIndex].agreement_signed &&
      allBiddersData[primaryBidderIndex].application_form_filled
    ) {
      payload["status"] = "verified";
    } else {
      payload["status"] = "pending";
    }

    payload["email"] = allBiddersData[primaryBidderIndex]?.email;
    payload["name"] = allBiddersData[primaryBidderIndex]?.name;
    payload["pan"] = allBiddersData[primaryBidderIndex]?.pan;
    payload["aadhar_number"] =
      allBiddersData[primaryBidderIndex]?.aadhar_number;
    payload["mobile_number"] =
      allBiddersData[primaryBidderIndex]?.mobile_number;
    payload["address"] = allBiddersData[primaryBidderIndex]?.address;
    payload["user_type"] = allBiddersData[primaryBidderIndex]?.user_type;
    payload["kyc_verified"] = allBiddersData[primaryBidderIndex]?.kyc_verified;
    payload["emd_amount_paid"] =
      allBiddersData[primaryBidderIndex]?.emd_amount_paid;
    payload["agreement_signed"] =
      allBiddersData[primaryBidderIndex]?.agreement_signed;
    payload["application_form_filled"] =
      allBiddersData[primaryBidderIndex]?.application_form_filled;
    payload["meta"] = {
      banker_email: banker?.attributes[0]?.value,
      bank_name: bank?.name,
      user_details: {
        address: payload["address"],
        mobile_number: payload["mobile_number"],
        aadhar_number: payload["aadhar_number"],
        user_type: payload["user_type"],
      },
      approver_email:
        eventData?.meta?.approver && eventData?.meta?.approver.length > 0
          ? eventData?.meta?.approver[0]?.email
          : "",
      approver_name:
        eventData?.meta?.approver && eventData?.meta?.approver.length > 0
          ? eventData?.meta?.approver[0]?.name
            ? eventData?.meta?.approver[0]?.name
            : eventData?.meta?.approver[0]?.email
          : "",
      branch_name: currentBranch?.label,
      event_name: eventData?.event_name,
      dashboard_url: `${process.env.NEXT_PUBLIC_BIDDER_DB_URL}/auction-events`,
      event_id: eventData.listing_id,
      auction_start_datetime: DateTime.fromISO(eventData?.start_date_time)
        .setZone("Asia/Kolkata")
        .toFormat("dd MMMM yyyy hh:mm a"),
      emd_last_datetime: DateTime.fromISO(
        eventData?.property_dump?.emd_last_date,
      )
        .setZone("Asia/Kolkata")
        .toFormat("dd MMMM yyyy hh:mm a"),
      name: payload.name,
      pan: payload.pan,
      ...(allBiddersData[primaryBidderIndex]?.initial_bid_price && {
        initial_bid_price:
          allBiddersData[primaryBidderIndex]?.initial_bid_price,
      }),
    };
    payload["is_joint"] = true;
    if (isOverwrite) {
      payload["is_overridden"] = true;
    }

    payload["access_type"] = "primary";
    payload["digio_request_status"] = "approved";
    payload["event_uuid"] = eventData?.uuid;

    return payload;
  };

  const getSecondaryBiddersPayload = () => {
    const secondaryBiddersData = [];
    console.log("primaryBidderIndex:2 ", primaryBidderIndex);
    const secondary = allBiddersData
      .filter((_: any, idx: any) => idx !== primaryBidderIndex)
      .filter(Boolean);
    console.log("secondary: ", secondary);

    for (let i = 0; i < secondary.length; i++) {
      let payload: any = {};
      if (
        secondary[i].kyc_verified &&
        secondary[i].emd_amount_paid &&
        secondary[i].agreement_signed &&
        secondary[i].application_form_filled
      ) {
        payload["status"] = "verified";
      } else {
        payload["status"] = "pending";
      }
      payload["email"] = secondary[i]?.email;
      payload["name"] = secondary[i]?.name;
      payload["pan"] = secondary[i]?.pan;
      payload["aadhar_number"] = secondary[i]?.aadhar_number;
      payload["mobile_number"] = secondary[i]?.mobile_number;
      payload["address"] = secondary[i]?.address;
      payload["user_type"] = secondary[i]?.user_type;
      payload["kyc_verified"] = secondary[i]?.kyc_verified;
      payload["emd_amount_paid"] = secondary[i]?.emd_amount_paid;
      payload["agreement_signed"] = secondary[i]?.agreement_signed;
      payload["application_form_filled"] =
        secondary[i]?.application_form_filled;
      payload["meta"] = {
        banker_email: banker?.attributes[0]?.value,
        bank_name: bank?.name,
        user_details: {
          address: payload["address"],
          mobile_number: payload["mobile_number"],
          aadhar_number: payload["aadhar_number"],
          user_type: payload["user_type"],
        },
        approver_email:
          eventData?.meta?.approver && eventData?.meta?.approver.length > 0
            ? eventData?.meta?.approver[0]?.email
            : "",
        approver_name:
          eventData?.meta?.approver && eventData?.meta?.approver.length > 0
            ? eventData?.meta?.approver[0]?.name
              ? eventData?.meta?.approver[0]?.name
              : eventData?.meta?.approver[0]?.email
            : "",
        branch_name: currentBranch?.label,
        event_name: eventData?.event_name,
        dashboard_url: `${process.env.NEXT_PUBLIC_BIDDER_DB_URL}/auction-events`,
        event_id: eventData.listing_id,
        auction_start_datetime: DateTime.fromISO(eventData?.start_date_time)
          .setZone("Asia/Kolkata")
          .toFormat("dd MMMM yyyy hh:mm a"),
        emd_last_datetime: DateTime.fromISO(
          eventData?.property_dump?.emd_last_date,
        )
          .setZone("Asia/Kolkata")
          .toFormat("dd MMMM yyyy hh:mm a"),
        name: payload.name,
        pan: payload.pan,
      };
      payload["is_joint"] = true;
      if (isOverwrite) {
        payload["is_overridden"] = true;
      }
      payload["access_type"] = "viewer";
      payload["digio_request_status"] = "approved";
      payload["event_uuid"] = eventData?.uuid;
      secondaryBiddersData.push(payload);
    }
    console.log("secondaryBiddersData: ", secondaryBiddersData);
    return secondaryBiddersData;
  };
  // console.log("d------->>", getPrimaryBidderPayload());
  // console.log("d2------->>", formatBidderNames(), getSecondaryBiddersPayload());

  const secondaryBiddersPayload = getSecondaryBiddersPayload();
  console.log("secondaryBiddersPayload: ", secondaryBiddersPayload);

  return {
    ...getPrimaryBidderPayload(),
    joint_bidders_payload: secondaryBiddersPayload,
  };
};

export default createJointBidderPayload;
